import { decode } from '../../server/lib/codec';
import {
  ResponseDeliveryInstructionsDetails,
  ResponseDeliveryInstructionsDetailsV,
  RequestDeliveryInstructionsDetails,
  RequestDeliveryInstructionsAddressVerificationFields,
  ParamsDeliveryInstructions,
  ParamDeliveryManagementCarrier,
} from '../../server/api/schema';

interface DetailsParams {
  addressVerification: RequestDeliveryInstructionsAddressVerificationFields;
  carrier: string;
  leaveAtValue: string;
  trackingNumber: ParamsDeliveryInstructions['trackingNumber'];
  registerAccount: RequestDeliveryInstructionsDetails<null>['registerAccount'];
  registerAccountDetails: RequestDeliveryInstructionsDetails<null>['registerAccountDetails'];
  allowDriverRelease: RequestDeliveryInstructionsDetails<null>['allowDriverRelease'];
  retailerMoniker: string;
  orderNumber?: string;
  sublimeEmail?: string;
}

const details = async ({
  addressVerification,
  carrier,
  leaveAtValue,
  trackingNumber,
  registerAccount,
  registerAccountDetails,
  allowDriverRelease,
  retailerMoniker,
  sublimeEmail,
  orderNumber,
}: DetailsParams): Promise<ResponseDeliveryInstructionsDetails> => {
  if (!Object.values<string>(ParamDeliveryManagementCarrier).includes(carrier))
    throw new Error(`Unsuppported carrier ${carrier}`);

  const url = `/api/v1/delivery-management/${carrier}/delivery-instructions/${trackingNumber}/details`;
  const body: RequestDeliveryInstructionsDetails<null> = {
    addressVerification,
    leaveAtValue,
    registerAccount,
    registerAccountDetails,
    allowDriverRelease,
    sublimeEmail,
    retailerMoniker,
    orderNumber,
  };

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const detailsJson: unknown = await response.json();
  const decoded = decode(ResponseDeliveryInstructionsDetailsV, detailsJson);
  return decoded;
};

export default details;
